import { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';

/**
 * Returns the employee UID being impersonated (i.e. the user who switched to this club admin account).
 * Mirrors the mobile app's getImpersonatingEmployeeUid — uses getIdTokenResult() instead of
 * synchronously parsing accessToken, which may be stale after a background token refresh.
 * Falls back to localStorage.lastUser (set by loginClub) in case the claim is no longer in the token.
 */
export const useImpersonatingUid = (deps: unknown[] = []): string | undefined => {
  const [impersonatingUid, setImpersonatingUid] = useState<string | undefined>(
    () => localStorage.getItem('lastUser') ?? undefined,
  );

  useEffect(() => {
    getAuth()
      .currentUser?.getIdTokenResult()
      .then((result) => {
        const uid = result?.claims?.impersonating_employee_uid as string | undefined;
        setImpersonatingUid(uid ?? localStorage.getItem('lastUser') ?? undefined);
      })
      .catch(() => {
        setImpersonatingUid(localStorage.getItem('lastUser') ?? undefined);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAuth().currentUser?.uid, ...deps]);

  return impersonatingUid;
};
